module.exports = __webpack_public_path__ + "img/co-investing-2.959a3f79.jpg";